import { LatLngLiteral } from '@agm/core';

export class ListaGeocerca {
    public cod_geocerca: string;
    public des_geocerca: string;
    public puntos: any;
    public visible: any;
    constructor(data: any) {
        //console.log(data)
        this.cod_geocerca = (data.gid)?data.gid:'';
        this.des_geocerca = (data.nombre)?data.nombre:'';
        this.visible = false;
        //let listaPuntos: Array <LatLngLiteral> = [];
        let listaPuntos = [];
        if(data.geometria){
            let geometria = data.geometria.split(',')
            geometria.forEach(el => {
                let latlong = el.split(' ');
                listaPuntos.push({ lat: parseFloat(latlong[1]), lng: parseFloat(latlong[0]) });
            });
        }
        /* if (data[0].coords) {
            data.forEach(el => {
                console.log(el)
                listaPuntos.push({ lat: el.lat, lng: el.lng });
            });
        } */
        this.puntos = listaPuntos;
    }
}